import * as React from 'react';
import { VendorViewModel } from '@models/Vendor';
import { SpinnerPage, Tabs, Tab } from '@common/components';
import { VendorInfoGeneralComponent } from 'src/vendor/_components/vendor-info/vendor-info-general.component';
import { VendorInfoAddressNFinancesComponent } from 'src/vendor/_components/vendor-info/vendor-info-address-n-finances.component';
import { VendorInfoCoverageNLimitsComponent } from 'src/vendor/_components/vendor-info/vendor-info-coverage-n-limits.component';
import { OptionsViewModel } from '@models/common.models';

export interface VendorInfoComponentProperties {
  readonly vendorVM: VendorViewModel;
  readonly w9StatusOptions?: OptionsViewModel[];
  readonly vendorGroupOptions?: OptionsViewModel[];
  readonly vendorTypeOptions?: OptionsViewModel[];
  readonly vendorStatusOptions?: OptionsViewModel[];
  readonly agreementTypeOptions?: OptionsViewModel[];
  readonly jump?: (step: number) => void | undefined;
  readonly isTabs?: boolean;
}

export class VendorInfoComponent extends React.Component<VendorInfoComponentProperties> {
  renderVendorInfoGeneralComponent = () => {
    return (
      <VendorInfoGeneralComponent
        companyName={this.props.vendorVM.companyName}
        id={this.props.vendorVM.id}
        emailAddress={this.props.vendorVM.emailAddress}
        dbaName={this.props.vendorVM.dbaName}
        vendorGroup={this.props.vendorVM.vendorGroup}
        vendorGroupOptions={this.props.vendorGroupOptions}
        businessPhone={this.props.vendorVM.businessPhone}
        businessFax={this.props.vendorVM.businessFax}
        afterHoursPhone={this.props.vendorVM.afterHoursPhone}
        ownerName={this.props.vendorVM.ownerName}
        managerName={this.props.vendorVM.managerName}
        jump={this.props.jump}
        isTab={this.props.isTabs}
        weekdayHours={this.props.vendorVM.weekdayHours}
        saturdayHours={this.props.vendorVM.saturdayHours}
        sundayHours={this.props.vendorVM.sundayHours}
        holidayHours={this.props.vendorVM.holidayHours}
      />
    );
  };

  renderVendorInfoAddressNFinancesComponent = () => {
    return (
      <VendorInfoAddressNFinancesComponent
        id={this.props.vendorVM.id}
        address={this.props.vendorVM.address!}
        apName={this.props.vendorVM.apName}
        parentId={this.props.vendorVM.parentId}
        vendorType={this.props.vendorVM.vendorType}
        vendorTypeOptions={this.props.vendorTypeOptions}
        vendorStatus={this.props.vendorVM.vendorStatus}
        vendorStatusOptions={this.props.vendorStatusOptions}
        licenseNumber={this.props.vendorVM.licenseNumber}
        licenseExpiration={this.props.vendorVM.licenseExpiration}
        taxId={this.props.vendorVM.taxId}
        has1099={this.props.vendorVM.has1099}
        w9Status={this.props.vendorVM.w9Status}
        w9StatusOptions={this.props.w9StatusOptions}
        w9SignedDate={this.props.vendorVM.w9SignedDate}
        w9TaxYear={this.props.vendorVM.w9TaxYear}
        jump={this.props.jump}
        isTab={this.props.isTabs}
      />
    );
  };

  renderVendorInfoCoverageNLimitsComponent = () => {
    return (
      <VendorInfoCoverageNLimitsComponent
        id={this.props.vendorVM.id}
        liabilityExpiration={this.props.vendorVM.liabilityExpiration}
        liabilityWaiver={this.props.vendorVM.liabilityWaiver}
        hourlyRate={this.props.vendorVM.hourlyRate}
        overtimeRate={this.props.vendorVM.overtimeRate}
        weekendRate={this.props.vendorVM.weekendRate}
        emergencyRate={this.props.vendorVM.emergencyRate}
        diagnosticRate={this.props.vendorVM.diagnosticRate}
        secondWorkerRate={this.props.vendorVM.secondWorkerRate}
        sdiExpiration={this.props.vendorVM.sdiExpiration}
        sdiWaiver={this.props.vendorVM.sdiWaiver}
        authoLimit={this.props.vendorVM.authoLimit}
        agreementDate={this.props.vendorVM.agreementDate}
        dispatchLimitPermanent={this.props.vendorVM.dispatchLimitPermanent}
        dispatchLimitTemp={this.props.vendorVM.dispatchLimitTemp}
        dispatchLimitExpiration={this.props.vendorVM.dispatchLimitTempExpiration}
        agreementType={this.props.vendorVM.agreementType}
        agreementTypeOptions={this.props.agreementTypeOptions}
        suspendedUntil={this.props.vendorVM.suspendedUntil}
        statReport={this.props.vendorVM.statReport}
        autoRerating={this.props.vendorVM.autoRerating}
        reportCard={this.props.vendorVM.reportCard}
        vendorPortal={this.props.vendorVM.vendorPortal}
        onlineAutho={this.props.vendorVM.onlineAutho}
        noBidding={this.props.vendorVM.noBidding}
        jump={this.props.jump}
        isTab={this.props.isTabs}
      />
    );
  };

  render() {
    if (!this.props.vendorVM) {
      return <SpinnerPage />;
    }

    return this.props.isTabs ? (
      <Tabs>
        <Tab title={'General Information'}>{this.renderVendorInfoGeneralComponent()}</Tab>
        <Tab title={'Address and Finance'}>{this.renderVendorInfoAddressNFinancesComponent()}</Tab>
        <Tab title={'Coverage Limits'}>{this.renderVendorInfoCoverageNLimitsComponent()}</Tab>
      </Tabs>
    ) : (
      <>
        <div className="row">
          <div className="col-xs-12">{this.renderVendorInfoGeneralComponent()}</div>
        </div>
        <div className="row">
          <div className="col-xs-6">{this.renderVendorInfoAddressNFinancesComponent()}</div>
          <div className="col-xs-6">{this.renderVendorInfoCoverageNLimitsComponent()}</div>
        </div>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-info/vendor-info.component.tsx